import useJwt from '@/auth/jwt/useJwt'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

export const getUserProfile = () => JSON.parse(localStorage.getItem('userProfile'))

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'SUPERADMINISTRADOR') return { name: 'app-dashboard-indicadores' }
  if (userRole === 'ADMINISTRADOR') return { name: 'app-administracion-institucion' } // app-administracion-proyecto
  if (userRole === 'GESTOR') return { name: 'app-encuesta-encuesta' }
  if (userRole === 'SUPERVISOR') return { name: 'app-dashboard-indicadores' }
  if (userRole === 'GERENTE') return { name: 'app-dashboard-indicadores' }
  if (userRole === 'ENCUESTADOR') return { name: 'app-reporte-encuestador' }
  /* if (userRole === 'admin') return '/'
  if (userRole === 'client') return { name: 'access-control' } */
  return { name: 'auth-login' }
}

export const getAbilityByRol = userRole => {
  const abilitys = [
    {
      action: 'manage',
      subject: 'Auth',
    },
    {
      action: 'manage',
      subject: 'rt-home',
    },
  ]
  if (userRole === 'ADMINISTRADOR') { // AL INICIAR SESSIÓN
    abilitys.push({
      action: 'manage',
      subject: 'app-administracion-proyecto',
    })
    abilitys.push({
      action: 'manage',
      subject: 'apps-seguridad-usuario',
    })
    abilitys.push({
      action: 'manage',
      subject: 'app-administracion-institucion',
    })
    return abilitys
  }
  if (userRole === 'ENCUESTADOR') {
    abilitys.push({
      action: 'manage',
      subject: 'app-reporte-encuestador',
    })
    return abilitys
  }
  if (userRole === 'GESTOR') {
    abilitys.push({
      action: 'manage',
      subject: 'app-dashboard-indicadores',
    })
    abilitys.push({
      action: 'manage',
      subject: 'app-encuesta-encuesta',
    })
    abilitys.push({
      action: 'manage',
      subject: 'app-encuesta-pregunta',
    })
    abilitys.push({
      action: 'manage',
      subject: 'app-encuesta-encuestador',
    })
    abilitys.push({
      action: 'manage',
      subject: 'app-encuesta-encuestado',
    })
    abilitys.push({
      action: 'manage',
      subject: 'app-cultivo-parcela',
    })
    return abilitys
  }
  if (userRole === 'SUPERVISOR') { // AL INICIAR SESSIÓN
    abilitys.push({
      action: 'manage',
      subject: 'app-dashboard-indicadores',
    })
    return abilitys
  }
  if (userRole === 'GERENTE') { // AL INICIAR SESSIÓN
    abilitys.push({
      action: 'manage',
      subject: 'app-dashboard-indicadores',
    })
    return abilitys
  }
  if (userRole === 'SUPERADMINISTRADOR') {
    return [
      {
        action: 'manage',
        subject: 'all',
      },
    ]
  }
  return [
    {
      action: 'read',
      subject: 'Auth',
    },
  ]
}
